<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
$(document).ready(function(){
  
  if ($(window).width() > 1024) { // Adjust the pixel value as needed for your breakpoint
    if ($('.slideshow lookbook-wrapper .lookbook-dialog.card').length) {
      $('.slideshow lookbook-wrapper .lookbook-dialog.card').attr('open', '');
    }

    if ($('.slideshow lookbook-wrapper .lookbook-dialog.card[open]').length) {
      $('.slideshow lookbook-wrapper .lookbook-dialog.card[open]').addClass('custom_product_position');
    }
  }

  // $('html, body').animate({ scrollTop: 850 }, 400);
  // setTimeout(function() {
  //   if($('.card-swatch .swatch-label.is-active')){
  //     $('.card-swatch .swatch-label.is-active').trigger('click');
  //   }
  // }, 2700);

    // if (window.location.pathname !== "/pages/coming-soon") {
    //     window.location.href = "/pages/coming-soon";
    // }


  // Wait for #product-tabs-section to be added to the DOM
// const observer = new MutationObserver(function(mutations) {
//   if ($('.product-item').length) {
//     if ($('.card-swatch .swatch-label.is-active').length) {
//       $('.card-swatch .swatch-label.is-active').trigger('click');
//     }
//     observer.disconnect(); // Stop observing after it's loaded
//   }
// });

// // Start observing the document body for changes
// observer.observe(document.body, { childList: true, subtree: true });



const target = document.querySelector('product-tabs-section .halo-block.halo-product-block');

if (target) {
  const observer = new MutationObserver((mutationsList) => {

    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        target.classList.contains('ajax-loaded')
      ) {
        observer.disconnect(); // Stop observing once class is added

        // Now run your code
        setTimeout(function() {
        if ($('.card-swatch .swatch-label.is-active').length) {
          $('.card-swatch .swatch-label.is-active').trigger('click');
        }
        }, 2000);
      }
    }
  });

  observer.observe(target, { attributes: true, attributeFilter: ['class'] });
}





    var variant_title = $('.product-form__swatch .product-form__radio:checked').val();
    var product_title = $('.productView-title span').attr('title');
    $('.productView-title span').html('');
    $('.productView-title span').append(product_title+' - '+ variant_title);
    
    
    $('.product-form__label .pattern').click(function(){
        var variant = $(this).attr('title');
        
        var product_title = $('.productView-title span').attr('title');
        $('.productView-title span').html('');
        var prod_title = $('.productView-title span').append(product_title+' - '+variant);
    })

    $(document).on('click', '.product-tab-block .list-product-tabs li .tab-links', function() { 
$('.product-tab-block .list-product-tabs li .tab-links').length
    // $('.product-tab-block .list-product-tabs li .tab-links').click(function(){
          console.log('working');
        setTimeout(function () {
          $('.product-tab-block .card-swatch .swatch-label.is-active').trigger('click');
        }, 2500);
    })
  $('.product-tab-block .list-product-tabs li .tab-links').on('click', function() {
    console.log('working');
});

  
})

// fetch(window.Shopify.routes.root + 'cart.js', {
//     method: 'GET',
// })
// .then(response => {
//     return response.json();
// }).then(response => {
//     if(response.item_count < 1){
//         $('.cart-count-bubble').hide();
//     }else{
//         $('.cart-count-bubble').show();
//     }
// })

   $(document).ready(function() {
      var freeGiftVariantId = 49179110768944; // Replace with your actual free gift variant ID
      var cartThreshold = 2500;
  
      function updateFreeGiftInCart() {
        $.getJSON('/cart.js', function(cart) {
          var subtotal = cart.total_price / 100; // Convert from cents/paise
          var giftItem = null;
  
          // Check if the gift is already in the cart
          $.each(cart.items, function(index, item) {
            if (item.variant_id === freeGiftVariantId) {
              giftItem = item;
              return false; // break loop
            }
          });
  
          if (subtotal >= cartThreshold && !giftItem) {
            // Add the free gift
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: freeGiftVariantId
              },
              dataType: 'json',
              success: function(response) {
                location.reload();
              }
            });
  
          } else {
            // Remove the free gift
            // $.ajax({
            //   type: 'POST',
            //   url: '/cart/change.js',
            //   data: {
            //     id: giftItem.key,
            //     quantity: 0
            //   },
            //   dataType: 'json',
            //   success: function(response) {
            //     console.log('🗑️ Free gift removed:', response);
            //     alert('Free gift removed as your cart total is below ₹2500.');
            //   }
            // });
          }
        });


      }
  
      // Initial check on page load
      updateFreeGiftInCart();
  
      // Re-check after item is added to cart (adjust as needed for your theme)
      $(document).on('click', '[name="add"], .add-to-cart, [data-btn-addtocart], [data-minus-quantity-cart], [data-plus-quantity-cart], .previewCartItem-remove', function() {
        setTimeout(updateFreeGiftInCart, 1500);
      });
  
      // Re-check if quantity changes or item is removed
      $(document).on('change', 'input[name="updates[]"], .cart__qty-input, [data-cart-quantity]', function() {
        setTimeout(updateFreeGiftInCart, 1500);
      });
    });
  
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
